// Components mounted by pages that load the `public` pack: everything a job
// page can mount (legacy custom job templates append `public` from
// jobs/_form), plus the other public layouts (`public`, `jobs_listing`) and
// the onboard candidate and setup portals.
//
// Checked against the views by
// app/javascript/public_rendering/__tests__/registry.test.js.
import jobPageComponents from './job_page_components';

const publicPageComponents = {
  ...jobPageComponents,
  'NewUI/Public/HintsAndTips': () => require('../components/NewUI/Public/HintsAndTips/index.tsx'),
  'NewUI/Public/HintsAndTips/PrintAction': () =>
    require('../components/NewUI/Public/HintsAndTips/PrintAction.tsx'),
  'NewUI/Public/JobsListing': () => require('../components/NewUI/Public/JobsListing/index.tsx'),
  'NewUI/Public/SeekVerificationUnsubscribe': () =>
    require('../components/NewUI/Public/SeekVerificationUnsubscribe/index.tsx'),
  'NewUI/Public/UnsubscribeCompletion': () =>
    require('../components/NewUI/Public/UnsubscribeCompletion/index.tsx'),
  OnboardPortal: () => require('@onboard/OnboardPortal.tsx'),
  OnboardSetupPortal: () => require('@onboard/OnboardSetupPortal.tsx')
};

export default publicPageComponents;
